import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../hooks/useStore';
import { DataViewEditBox, useForm } from '../../../../lib/components';
import { ContactDataForm } from './form';
import { ContactDataView } from './view';

export const CompanyContactData = observer(() => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const form = useForm();

  const renderView = observer(() => <ContactDataView data={companyStore.contactData} />);

  const renderEdit = () => {
    return (
      <ContactDataForm
        initialValues={{
          first_name: companyStore.contactData?.first_name || '',
          last_name: companyStore.contactData?.last_name || '',
          email: companyStore.contactData?.email || '',
          phone: companyStore.contactData?.phone || ''
        }}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (values) => {
          try {
            await companyStore.updateContactData(values);
          } catch (error) {
            console.error(error);
          }
        }}
        useCustomButton
      />
    );
  };
  return (
    <DataViewEditBox
      title={t('company:CONTACT_DATA')}
      view={renderView}
      edit={renderEdit}
      canEdit
      canSubmit={canSubmit}
      onSubmit={form.handleSubmit}
      onCancel={form.handleReset}
    />
  );
});
